export const DOSSIER_SETTINGS_QUERY_KEY = "dossier-settings" as const;
